"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _purchaseLoginBg = _interopRequireDefault(require("./resources/purchaseLoginBg.svg"));
var _purchaseLoginMobileBg = _interopRequireDefault(require("./resources/purchaseLoginMobileBg.svg"));
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = props => {
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    fontFamily,
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    layout = 'popup',
    isWithPurchase = false
  } = props;
  const {
    pxToRem,
    scrollProps
  } = (0, _hooks.useStylesUtils)();
  const ccLoginStyle = (0, _react.useMemo)(() => {
    const mobileLayoutProps = () => {
      if (layout === 'inline' && isMobileView) {
        return {
          height: '100%'
        };
      }
      return {};
    };
    const purchaseMobileProps = () => {
      if (isWithPurchase) {
        if (isMobileView) {
          return {
            backgroundImage: `url(${_purchaseLoginMobileBg.default})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'center'
          };
        }
        return {
          borderRadius: pxToRem(10),
          height: pxToRem(420),
          backgroundColor: themeColors?.general.light,
          backgroundImage: `url(${_purchaseLoginBg.default})`,
          backgroundSize: '70%',
          backgroundPosition: 'top 50% right -1%',
          display: 'flex',
          justifyContent: 'space-between'
        };
      } else {
        if (isMobileView) {
          return {
            display: 'flex',
            justifyContent: 'center',
            height: '100%'
          };
        }
        return {
          borderRadius: pxToRem(10),
          // aspectRatio: '9/6',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%'
        };
      }
    };
    const loginSectionPurchaseMobileProps = () => {
      if (isWithPurchase && isMobileView) {
        return {
          height: '50%'
        };
      }
      return {};
    };
    const buttonsPurchaseProps = () => {
      if (isWithPurchase) {
        return {
          margin: '0 auto'
        };
      }
      return {};
    };
    const ccLogin = (0, _css.css)({
      fontFamily: fontFamily,
      ...mobileLayoutProps()
    });
    const ccLoginContent = (0, _css.css)({
      overflow: 'auto',
      backgroundRepeat: 'no-repeat',
      padding: pxToRem(40),
      ...scrollProps(),
      ...purchaseMobileProps()
    });
    const ccLoginSection = (0, _css.css)({
      paddingTop: isWithPurchase ? pxToRem(10) : '',
      ...loginSectionPurchaseMobileProps()
    });
    const ccLoginButtons = (0, _css.css)({
      width: pxToRem(290),
      height: pxToRem(245),
      position: 'relative',
      ...buttonsPurchaseProps()
    });
    const ccLoginTitlePurchase = (0, _css.css)({
      marginBlockEnd: pxToRem(20)
    });
    const ccLoginTitleContainer = (0, _css.css)({
      marginBlockEnd: pxToRem(20),
      h1: {
        margin: 0,
        fontSize: pxToRem(54),
        lineHeight: pxToRem(50),
        color: themeColors?.primary.main,
        textAlign: 'center',
        marginBlockEnd: pxToRem(5)
      },
      h3: {
        margin: 0,
        color: '#545454',
        fontSize: pxToRem(26),
        lineHeight: pxToRem(30),
        fontWeight: 'normal',
        textAlign: 'center'
      }
    });
    const ccLoginIdmBtn = (0, _css.css)({
      '&:focus-visible': {
        border: '3px solid black'
      }
    });
    const ccLoginCetBtn = (0, _css.css)({
      marginTop: pxToRem(30),
      '&:focus-visible': {
        border: '3px solid black'
      }
    });
    const ccLoginIdmDesc = (0, _css.css)({
      fontSize: pxToRem(17),
      color: isWithPurchase ? '#fff' : themeColors?.primary.main,
      textAlign: 'center',
      lineHeight: pxToRem(17)
    });
    return {
      ccLogin,
      ccLoginContent,
      ccLoginSection,
      ccLoginButtons,
      ccLoginTitlePurchase,
      ccLoginTitleContainer,
      ccLoginIdmBtn,
      ccLoginCetBtn,
      ccLoginIdmDesc
    };
  }, [fontFamily, isMobileView, isWithPurchase, layout, pxToRem, scrollProps, themeColors?.general.light, themeColors?.primary.main]);
  return {
    'cc-Login': ccLoginStyle.ccLogin,
    'cc-Login__content': ccLoginStyle.ccLoginContent,
    'cc-Login__login-section': ccLoginStyle.ccLoginSection,
    'cc-Login__buttons': ccLoginStyle.ccLoginButtons,
    'cc-Login__title-purchase': ccLoginStyle.ccLoginTitlePurchase,
    'cc-Login__title_container': ccLoginStyle.ccLoginTitleContainer,
    'cc-Login__idm_btn': ccLoginStyle.ccLoginIdmBtn,
    'cc-Login__cet_btn': ccLoginStyle.ccLoginCetBtn,
    'cc-Login__idm_desc': ccLoginStyle.ccLoginIdmDesc
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;